import Box from "@mui/material/Box";
import FabricSection from "./FabricSection/FabricSection";
import TrimsSection from "./TrimsSection/TrimsSection";
import ValueAddSection from "./ValueAddSection/ValueAddSection";
import { useEffect, useMemo, useState } from "react";
import { PimDashboardState } from "context/PimDashboardContext";
import {
	normalizeStyleFabricItems,
	normalizeStyleTrimsItems,
	normalizeStyleValueAddItems,
	styleFabricAssociation,
	styleTrimsAssociation,
	styleValueAddAssocition,
} from "./data";
import { GlobalState } from "context/GlobalContext";
import { useSearchParams } from "react-router-dom";
import { styleUrlKey } from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/data";
import axios from "axios";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";

const FabricAndTrims = ({ isActive = true }) => {
	const { selectedStyle } = PimDashboardState();
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen } = GlobalState();
	const [searchParams] = useSearchParams();
	const [fabricTrimsData, setFabricTrimsData] = useState();
	const [updatedFabricArr, setUpdatedFabricArr] = useState([]);
	const [updatedTrimsArr, setUpdatedTrimsArr] = useState([]);
	const [updatedValueAddArr, setUpdatedValueAddArr] = useState([]);
	const styleId = searchParams.get(styleUrlKey) || selectedStyle?.style_id;
	const styleFabricArr = useMemo(() => normalizeStyleFabricItems(fabricTrimsData), [fabricTrimsData]);
	const styleTrimsArr = useMemo(() => normalizeStyleTrimsItems(fabricTrimsData), [fabricTrimsData]);
	const styleValueAddArr = useMemo(() => normalizeStyleValueAddItems(fabricTrimsData), [fabricTrimsData]);

	useEffect(() => {
		if (!styleId || !isActive) {
			return;
		}

		const fetchFabricTrimsData = async () => {
			setLoadingOpen(true);
			try {
				const res = await axios.get(`/api/fabric_trims/get_fabric_trims_data?styleId=${styleId}`);
				setFabricTrimsData(res?.data?.result);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
			} finally {
				setLoadingOpen(false);
			}
		};

		fetchFabricTrimsData();
	}, [styleId, isActive]);

	useEffect(() => {
		setUpdatedFabricArr([]);
		setUpdatedTrimsArr([]);
		setUpdatedValueAddArr([]);
	}, [fabricTrimsData?.style_id]);

	return (
		<Box display="flex" flexDirection="column" rowGap={2}>
			<FabricSection
				styleId={styleId}
				styleFabricArr={styleFabricArr}
				sectionDetails={fabricTrimsData?.[styleFabricAssociation]}
				onSectionDetailsUpdate={(updatedDetails) =>
					setFabricTrimsData((prev) => ({
						...(prev ?? {}),
						[styleFabricAssociation]: {
							...(prev?.[styleFabricAssociation] ?? {}),
							...updatedDetails,
						},
					}))
				}
				updatedFabricArr={updatedFabricArr}
				setUpdatedFabricArr={setUpdatedFabricArr}
				setStyleFabricArr={(newFabricArr) =>
					setFabricTrimsData((prev) => ({
						...(prev ?? {}),
						[styleFabricAssociation]: {
							...(prev?.[styleFabricAssociation] ?? {}),
							styleFabricDetailItems: newFabricArr,
						},
					}))
				}
				enableConsumptionEdit={false}
			/>
			<TrimsSection
				styleId={styleId}
				styleFabricArr={styleFabricArr}
				styleTrimsArr={styleTrimsArr}
				sectionDetails={fabricTrimsData?.[styleTrimsAssociation]}
				onSectionDetailsUpdate={(updatedDetails) =>
					setFabricTrimsData((prev) => ({
						...(prev ?? {}),
						[styleTrimsAssociation]: {
							...(prev?.[styleTrimsAssociation] ?? {}),
							...updatedDetails,
						},
					}))
				}
				updatedTrimsArr={updatedTrimsArr}
				setUpdatedTrimsArr={setUpdatedTrimsArr}
				setStyleTrimsArr={(newTrimsArr) =>
					setFabricTrimsData((prev) => ({
						...(prev ?? {}),
						[styleTrimsAssociation]: {
							...(prev?.[styleTrimsAssociation] ?? {}),
							styleTrimsDetailItems: newTrimsArr,
						},
					}))
				}
			/>
			<ValueAddSection
				styleId={styleId}
				styleValueAddArr={styleValueAddArr}
				sectionDetails={fabricTrimsData?.[styleValueAddAssocition]}
				onSectionDetailsUpdate={(updatedDetails) =>
					setFabricTrimsData((prev) => ({
						...(prev ?? {}),
						[styleValueAddAssocition]: {
							...(prev?.[styleValueAddAssocition] ?? {}),
							...updatedDetails,
						},
					}))
				}
				updatedValueAddArr={updatedValueAddArr}
				setUpdatedValueAddArr={setUpdatedValueAddArr}
				setStyleValueAddArr={(newValueAddArr) =>
					setFabricTrimsData((prev) => ({
						...(prev ?? {}),
						[styleValueAddAssocition]: {
							...(prev?.[styleValueAddAssocition] ?? {}),
							styleValueAddDetailItems: newValueAddArr,
						},
					}))
				}
			/>
		</Box>
	);
};

export default FabricAndTrims;
